import { render } from "./SearchSuggestion.vue?vue&type=template&id=57d0c34a&lang=pug"
import script from "./SearchSuggestion.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchSuggestion.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QItem from 'quasar/src/components/item/QItem.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QItem,QChip});
